import { render, staticRenderFns } from "./PurchaseDetailedList.vue?vue&type=template&id=47e897a8&scoped=true&"
import script from "./PurchaseDetailedList.vue?vue&type=script&lang=js&"
export * from "./PurchaseDetailedList.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseDetailedList.vue?vue&type=style&index=0&id=47e897a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e897a8",
  null
  
)

export default component.exports